// extracted by mini-css-extract-plugin
export default {"backgroundMode":"ElencoAssistentiFamiliari_backgroundMode__4XI4U","buttonTable":"ElencoAssistentiFamiliari_buttonTable__qvQIP"};